import { navigateTo } from '@app/core/routing';
import { allApiModules, buildApiClient } from '@mi-front/core';
import { AxiosError } from 'axios';
import { config } from '../config';

export const apiClient = buildApiClient(
  {
    apiRoot: config.apiRoot,
  },
  allApiModules,
);

type AuthErrorResponse = {
  code?: string;
};

apiClient.onUnauthentication((err: AxiosError) => {
  const responseData = (err.response?.data || {}) as AuthErrorResponse;

  if (responseData.code === 'invalid_token') {
    navigateTo('/logout');
  }
});
